import dayjs from "dayjs";

import { BsSearch } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import { FaPrint } from "react-icons/fa";

type Props = {
	startDate: string;
	setStartDate: (startDate: string) => void;
	endDate: string;
	setEndDate: (endDate: string) => void;
	youngerAge?: number;
	setYoungerAge: (youngerAge?: number) => void;
	olderAge?: number;
	setOlderAge: (olderAge?: number) => void;
	handleFilter: () => void;
};

export function DeadPatientsFilters({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	youngerAge,
	setYoungerAge,
	olderAge,
	setOlderAge,
	handleFilter,
}: Readonly<Props>) {
	return (
		<Form
			onSubmit={(event) => {
				event.preventDefault();
				handleFilter();
			}}
		>
			<Row>
				<Col sm={12} md={6} lg={6} xl={4} className="align-items-center mb-3">
					<Form.Label>Período</Form.Label>
					<div className="d-flex gap-3">
						<InputGroup>
							<Form.Control
								type="datetime-local"
								value={startDate}
								placeholder="Data inicial"
								min={dayjs()
									.subtract(2, "years")
									.startOf("day")
									.format("YYYY-MM-DDTHH:mm")}
								max={dayjs().endOf("day").format("YYYY-MM-DDTHH:mm")}
								onChange={(event) => setStartDate(event.target.value)}
							/>
						</InputGroup>
						<InputGroup>
							<Form.Control
								type="datetime-local"
								value={endDate}
								placeholder="data final"
								min={startDate}
								max={dayjs().endOf("day").format("YYYY-MM-DDTHH:mm")}
								onChange={(event) => setEndDate(event.target.value)}
							/>
						</InputGroup>
					</div>
				</Col>
				<Col sm={2} md={2} lg={6} xl={2} className="d-flex flex-column mb-3">
					<Form.Label>Faixa etária:</Form.Label>
					<InputGroup className="gap-3">
						<Form.Control
							type="number"
							min={0}
							defaultValue={youngerAge}
							className="fs-7 p-2"
							placeholder="mín"
							onChange={(event) =>
								Boolean(event.target.value)
									? setYoungerAge(Number(event.target.value))
									: setYoungerAge()
							}
						/>
						<Form.Control
							type="number"
							min={youngerAge}
							defaultValue={olderAge}
							className="fs-7 p-2"
							placeholder="max"
							onChange={(event) =>
								Boolean(event.target.value)
									? setOlderAge(Number(event.target.value))
									: setOlderAge()
							}
						/>
					</InputGroup>
				</Col>
				<Col sm={12} md={6} lg={6} xl={3} className="d-flex align-items-end gap-3 mb-3">
					<Button type="submit" className="text-nowrap">
						<BsSearch className="me-2" />
						Consultar
					</Button>
					<Button type="submit" className="text-nowrap">
						<FaPrint className="me-2" />
						Imprimir
					</Button>
				</Col>
			</Row>
		</Form>
	);
}
